import React, { useState, useEffect, useMemo } from 'react';
import { useData } from '../context/DataContext';

const ESTADO_COLORS = {
  'Concretado':            { bg:'#dcfce7', text:'#16a34a', border:'#bbf7d0' },
  'No concretado':         { bg:'#fee2e2', text:'#dc2626', border:'#fecaca' },
  'Prospecto calificado':  { bg:'#dbeafe', text:'#1d4ed8', border:'#bfdbfe' },
};

function EstadoBadge({ estado }) {
  const c = ESTADO_COLORS[estado] || ESTADO_COLORS['Prospecto calificado'];
  return (
    <span style={{ background:c.bg, color:c.text, border:`1px solid ${c.border}`, borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700, whiteSpace:'nowrap' }}>
      {estado}
    </span>
  );
}

function ModalCliente({ cliente, onClose, onEstado, onNota }) {
  const [nota, setNota]       = useState('');
  const [saving, setSaving]   = useState(false);
  const [tab, setTab]         = useState('info');

  const handleEstado = async (estado) => {
    setSaving(true);
    await onEstado(cliente.rowIndex, estado);
    setSaving(false);
  };

  const handleNota = async () => {
    if (!nota.trim()) return;
    setSaving(true);
    await onNota(cliente.rowIndex, nota.trim());
    setNota('');
    setSaving(false);
  };

  const notasArray = cliente.notas
    ? cliente.notas.split('\n').filter(Boolean).reverse()
    : [];

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background:'#fff', borderRadius:16, width:'100%', maxWidth:560, maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>
        {/* Header */}
        <div style={{ background:'#185fa5', padding:'20px 24px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <h2 style={{ margin:0, color:'#fff', fontSize:18, fontWeight:800 }}>{cliente.nombre}</h2>
            <p style={{ margin:'4px 0 0', color:'rgba(255,255,255,0.75)', fontSize:13 }}>{cliente.telefono}</p>
          </div>
          <button onClick={onClose} style={{ background:'rgba(255,255,255,0.2)', border:'none', color:'#fff', width:32, height:32, borderRadius:8, cursor:'pointer', fontSize:18 }}>×</button>
        </div>

        {/* Tabs */}
        <div style={{ display:'flex', borderBottom:'1px solid #e2e8f0' }}>
          {['info','docs','notas'].map(t => (
            <button key={t} onClick={() => setTab(t)}
              style={{ flex:1, padding:'12px 0', border:'none', background:'none', cursor:'pointer', fontSize:13, fontWeight:700,
                color: tab===t ? '#185fa5' : '#94a3b8',
                borderBottom: tab===t ? '2px solid #185fa5' : '2px solid transparent' }}>
              {t === 'info' ? '📋 Datos' : t === 'docs' ? '🪪 Documentos' : '📝 Notas'}
            </button>
          ))}
        </div>

        {/* Body */}
        <div style={{ flex:1, overflow:'auto', padding:24 }}>
          {tab === 'info' && (
            <div>
              <Row label="Nombre" value={cliente.nombre} />
              <Row label="Teléfono" value={cliente.telefono} />
              <Row label="Modelo de interés" value={cliente.modelo || '—'} />
              <Row label="Fuente" value={cliente.fuente || '—'} />
              <Row label="Fecha" value={cliente.fecha || '—'} />
              <div style={{ marginTop:4 }}>
                <p style={{ fontSize:12, color:'#94a3b8', marginBottom:8, fontWeight:600 }}>ESTADO</p>
                <EstadoBadge estado={cliente.estado} />
              </div>
              <div style={{ marginTop:20 }}>
                <p style={{ fontSize:12, color:'#94a3b8', marginBottom:10, fontWeight:600 }}>CAMBIAR ESTADO</p>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  {['Concretado','No concretado','Prospecto calificado'].map(est => (
                    <button key={est} onClick={() => handleEstado(est)} disabled={saving || cliente.estado === est}
                      style={{ padding:'8px 14px', borderRadius:8, border:'1px solid #e2e8f0', cursor:'pointer', fontSize:13, fontWeight:600,
                        background: cliente.estado === est ? '#185fa5' : '#fff',
                        color: cliente.estado === est ? '#fff' : '#475569',
                        opacity: saving ? 0.6 : 1 }}>
                      {est}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {tab === 'docs' && (
            <div style={{ display:'flex', flexDirection:'column', gap:24 }}>
              <DocCard label="Foto INE" url={cliente.ine_url} />
              <DocCard label="Comprobante de domicilio" url={cliente.comp_url} />
            </div>
          )}

          {tab === 'notas' && (
            <div>
              <div style={{ marginBottom:16 }}>
                <textarea value={nota} onChange={e=>setNota(e.target.value)} placeholder="Escribe una nota..."
                  style={{ width:'100%', minHeight:80, padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', resize:'vertical', boxSizing:'border-box', fontFamily:'inherit' }} />
                <button onClick={handleNota} disabled={saving || !nota.trim()}
                  style={{ marginTop:8, padding:'10px 20px', background:'#185fa5', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700, opacity: saving||!nota.trim() ? 0.6 : 1 }}>
                  {saving ? 'Guardando...' : 'Agregar nota'}
                </button>
              </div>
              {notasArray.length === 0
                ? <p style={{ color:'#94a3b8', fontSize:13, textAlign:'center', marginTop:24 }}>Sin notas aún</p>
                : notasArray.map((n,i) => (
                  <div key={i} style={{ background:'#f8fafc', borderRadius:8, padding:'10px 14px', marginBottom:8, fontSize:13, color:'#0f172a', borderLeft:'3px solid #185fa5' }}>
                    {n}
                  </div>
                ))
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ marginBottom:14 }}>
      <p style={{ fontSize:11, color:'#94a3b8', fontWeight:700, margin:'0 0 3px', textTransform:'uppercase', letterSpacing:0.5 }}>{label}</p>
      <p style={{ fontSize:14, color:'#0f172a', margin:0, fontWeight:500 }}>{value}</p>
    </div>
  );
}

function DocCard({ label, url }) {
  const isUrl = url && (url.startsWith('http') || url.startsWith('//'));
  return (
    <div style={{ border:'1px solid #e2e8f0', borderRadius:12, overflow:'hidden' }}>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderBottom:'1px solid #e2e8f0' }}>
        <p style={{ margin:0, fontSize:13, fontWeight:700, color:'#0f172a' }}>{label}</p>
      </div>
      {isUrl ? (
        <div style={{ padding:16 }}>
          <img src={url} alt={label} style={{ width:'100%', borderRadius:8, display:'block' }}
            onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='flex'; }} />
          <div style={{ display:'none', flexDirection:'column', alignItems:'center', gap:8, padding:24 }}>
            <span style={{ fontSize:32 }}>🔗</span>
            <a href={url} target="_blank" rel="noopener noreferrer"
              style={{ color:'#185fa5', fontSize:13, fontWeight:600 }}>Ver imagen en nueva pestaña</a>
          </div>
        </div>
      ) : (
        <div style={{ padding:32, textAlign:'center', color:'#94a3b8', fontSize:13 }}>Sin documento</div>
      )}
    </div>
  );
}

export default function Clientes() {
  const { clientes, loading, error, cargarClientes, cambiarEstado, agregarNota } = useData();
  const [busqueda, setBusqueda]     = useState('');
  const [filtroEstado, setFiltro]   = useState('Todos');
  const [selected, setSelected]     = useState(null);
  const [toastMsg, setToastMsg]     = useState('');

  useEffect(() => { cargarClientes(); }, [cargarClientes]);

  const toast = (msg) => { setToastMsg(msg); setTimeout(() => setToastMsg(''), 3000); };

  const handleEstado = async (rowIndex, estado) => {
    await cambiarEstado(rowIndex, estado);
    toast('Estado actualizado: ' + estado);
    setSelected(prev => prev ? { ...prev, estado } : prev);
  };

  const handleNota = async (rowIndex, nota) => {
    await agregarNota(rowIndex, nota);
    toast('Nota guardada');
    const ts = new Date().toLocaleString('es-MX',{timeZone:'America/Mexico_City',hour12:false});
    setSelected(prev => {
      if (!prev) return prev;
      const n = prev.notas ? prev.notas + '\n[' + ts + '] ' + nota : '[' + ts + '] ' + nota;
      return { ...prev, notas: n };
    });
  };

  const filtrados = useMemo(() => {
    return clientes.filter(c => {
      const q = busqueda.toLowerCase();
      const matchQ = !q || c.nombre.toLowerCase().includes(q) || c.telefono.includes(q) || (c.modelo||'').toLowerCase().includes(q);
      const matchE = filtroEstado === 'Todos' || c.estado === filtroEstado;
      return matchQ && matchE;
    });
  }, [clientes, busqueda, filtroEstado]);

  return (
    <div style={{ padding:'24px 24px 80px', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24, flexWrap:'wrap', gap:12 }}>
        <div>
          <h1 style={{ margin:0, fontSize:22, fontWeight:800, color:'#0f172a' }}>Clientes</h1>
          <p style={{ margin:'4px 0 0', color:'#94a3b8', fontSize:13 }}>{clientes.length} prospectos registrados</p>
        </div>
        <button onClick={cargarClientes} disabled={loading}
          style={{ padding:'9px 18px', background:'#185fa5', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700, display:'flex', alignItems:'center', gap:6 }}>
          {loading ? '⟳ Cargando...' : '⟳ Actualizar'}
        </button>
      </div>

      {/* Filtros */}
      <div style={{ display:'flex', gap:12, marginBottom:20, flexWrap:'wrap' }}>
        <input value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar por nombre, teléfono o modelo..."
          style={{ flex:1, minWidth:200, padding:'9px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none' }} />
        <select value={filtroEstado} onChange={e=>setFiltro(e.target.value)}
          style={{ padding:'9px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', background:'#fff', cursor:'pointer' }}>
          <option>Todos</option>
          <option>Prospecto calificado</option>
          <option>Concretado</option>
          <option>No concretado</option>
        </select>
      </div>

      {/* Error */}
      {error && (
        <div style={{ background:'#fee2e2', border:'1px solid #fecaca', borderRadius:10, padding:'12px 16px', color:'#dc2626', fontSize:13, marginBottom:16 }}>
          ⚠️ {error}
        </div>
      )}

      {/* Lista */}
      {loading && clientes.length === 0 ? (
        <div style={{ textAlign:'center', padding:60, color:'#94a3b8' }}>
          <div style={{ fontSize:32, marginBottom:12 }}>⟳</div>
          <p>Cargando clientes...</p>
        </div>
      ) : filtrados.length === 0 ? (
        <div style={{ textAlign:'center', padding:60, color:'#94a3b8' }}>
          <div style={{ fontSize:40, marginBottom:12 }}>👤</div>
          <p style={{ fontWeight:600 }}>No hay clientes{busqueda ? ' con esa búsqueda' : ''}</p>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {filtrados.map(c => (
            <div key={c.rowIndex} style={{ background:'#fff', borderRadius:12, padding:'14px 18px', boxShadow:'0 1px 3px rgba(0,0,0,0.08)', display:'flex', alignItems:'center', gap:14, cursor:'pointer', transition:'box-shadow 0.15s' }}
              onClick={() => setSelected(c)}
              onMouseEnter={e => e.currentTarget.style.boxShadow='0 4px 16px rgba(24,95,165,0.12)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'}>

              {/* Avatar */}
              <div style={{ width:44, height:44, borderRadius:22, background:'#185fa5', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:800, fontSize:18, flexShrink:0 }}>
                {c.nombre.charAt(0).toUpperCase()}
              </div>

              {/* Info */}
              <div style={{ flex:1, minWidth:0 }}>
                <p style={{ margin:0, fontWeight:700, fontSize:14, color:'#0f172a', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{c.nombre}</p>
                <p style={{ margin:'2px 0 0', fontSize:12, color:'#94a3b8' }}>{c.telefono} {c.modelo ? '· ' + c.modelo : ''}</p>
              </div>

              {/* Estado badge + botón rápido */}
              <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:6, flexShrink:0 }}>
                <EstadoBadge estado={c.estado} />
                <div style={{ display:'flex', gap:4 }} onClick={e => e.stopPropagation()}>
                  {c.estado !== 'Concretado' && (
                    <button onClick={() => handleEstado(c.rowIndex, 'Concretado')}
                      style={{ padding:'4px 8px', background:'#dcfce7', color:'#16a34a', border:'1px solid #bbf7d0', borderRadius:6, fontSize:11, fontWeight:700, cursor:'pointer' }}>
                      ✓ Concretar
                    </button>
                  )}
                  {c.estado !== 'No concretado' && (
                    <button onClick={() => handleEstado(c.rowIndex, 'No concretado')}
                      style={{ padding:'4px 8px', background:'#fee2e2', color:'#dc2626', border:'1px solid #fecaca', borderRadius:6, fontSize:11, fontWeight:700, cursor:'pointer' }}>
                      ✗
                    </button>
                  )}
                </div>
              </div>

              {/* Fecha */}
              <div style={{ fontSize:11, color:'#94a3b8', flexShrink:0, textAlign:'right', minWidth:70, display:'flex', flexDirection:'column', alignItems:'flex-end', gap:2 }}>
                {c.fecha ? c.fecha.slice(0,10) : ''}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {selected && (
        <ModalCliente
          cliente={selected}
          onClose={() => setSelected(null)}
          onEstado={handleEstado}
          onNota={handleNota}
        />
      )}

      {/* Toast */}
      {toastMsg && (
        <div style={{ position:'fixed', bottom:60, left:'50%', transform:'translateX(-50%)', background:'#0f172a', color:'#fff', padding:'10px 20px', borderRadius:10, fontSize:13, fontWeight:600, zIndex:999, whiteSpace:'nowrap' }}>
          {toastMsg}
        </div>
      )}
    </div>
  );
}
